// extracted by css-extract-rspack-plugin
export default {"Icon":"src-wab-client-components-auth-ConnectOAuth-module__Icon-XbcxZH","icon":"src-wab-client-components-auth-ConnectOAuth-module__Icon-XbcxZH"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"Icon\":\"src-wab-client-components-auth-ConnectOAuth-module__Icon-XbcxZH\",\"icon\":\"src-wab-client-components-auth-ConnectOAuth-module__Icon-XbcxZH\"}";
        // 1791313081732
        var cssReload = require("../../../../../../node_modules/.pnpm/@rspack+core@1.7.12_@swc+helpers@0.5.23/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  